export const ADD_CART="ADD_CART";
export const REMOVE_DATA_FROM_CART="REMOVE_DATA_FROM_CART";
